import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-1977caa1"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "breadcrumb"
};
var _hoisted_2 = ["src"];
var _hoisted_3 = ["innerHTML"];
import info from '@/api/info';
import { $formErr, $getCdnUrl, $getInfo } from '@/assets/common/common.js';
import avatarPng from '@/assets/image/avatar.png';
import { useLang } from '@/hooks/lang';
import { SOFTWAREFLAG } from '@/utils/config';
import privacyPolicy from '@shining3d/info-component/infoList/privacyPolicy.vue';
import { useMatomo } from '@shining3d/matomo';
import { XlImgCropperOss } from '@shining3d/ui-components';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
export default {
  setup: function setup(__props) {
    var $store = useStore();
    var router = useRouter();
    var _throttle = require('lodash/throttle');
    var _get = require('lodash/get');
    var _useLang = useLang('@shining3d/app'),
      $t = _useLang.$t;
    // 侧边菜单
    var routerList = ref([{
      path: '/info/personalInfo',
      name: $t('personalInformation.side.info'),
      icon: 'icon-gerenzhongxin'
    }, {
      path: '/info/accountPassword',
      name: $t('personalInformation.side.password'),
      icon: 'icon-zhanghaomima'
    }, {
      path: '/info/industry',
      name: $t('industryInfo.industryInfoText'),
      icon: 'icon-qiyemingcheng'
    }]);

    // 判断是否为软件端如tx3，e15，并作页面定制化
    var loginType = sessionStorage.getItem(SOFTWAREFLAG) ? 'SOFTWARE' : '';
    var errorHandler = function errorHandler() {
      return true;
    };
    var matomo = useMatomo();
    var uploaded = function uploaded(val, callbacks) {
      console.log(val);
      info.setAvatar({
        bucket: _get(val, 'bucket'),
        dfsID: _get(val, 'dfsID'),
        fileName: _get(val, 'file.name')
      }).then(function () {
        $getInfo();
        matomo.log('click', '我的|用户头像|上传头像', '提交头像上传');
        callbacks(true);
      }).catch(function (e) {
        $formErr(e.data, '', 'msg');
      });
    };

    // 隐私政策、用户协议等弹窗
    var termsOfUseRef = ref(null);
    var policyType = ref('');
    var policyTitle = ref('');
    var privacyPolicySwitch = computed(function () {
      return $store.state.privacyPolicySwitchInfo;
    });
    var termsOfUseSwitch = computed(function () {
      return $store.state.termsOfUseSwitchInfo;
    });
    var dataMigrateSwitch = computed(function () {
      return $store.state.dataMigrateSwitchInfo;
    });
    var orgDissolveNoticeSwitch = computed(function () {
      return $store.state.orgDissolveNoticeSwitchInfo;
    });
    var tcpChange = function tcpChange(title, type) {
      policyTitle.value = title;
      policyType.value = type;
      nextTick(function () {
        termsOfUseChange();
      });
    };
    var termsOfUseChange = function termsOfUseChange() {
      termsOfUseRef.value.getInfo();
      termsOfUseRef.value.dialogVisible = true;
    };
    var pChange = _throttle(function (title, type) {
      tcpChange(title, type);
    }, 2000, {
      leading: true,
      trailing: false
    });

    // 隐私政策
    watch(privacyPolicySwitch, function (val) {
      pChange('app-login.privacyPolicy', 'privacy');
    });

    // 使用条款
    watch(termsOfUseSwitch, function (val) {
      pChange('app-login.termsOfUse', 'termsOfUse');
    });

    // 数据迁移声明
    watch(dataMigrateSwitch, function (val) {
      pChange('institutionMore.dataMigrate.notice.statement', 'dataMigrateNotice');
    });

    // 机构解散须知
    watch(orgDissolveNoticeSwitch, function (val) {
      pChange('institutionMore.dissolve.notice.noticeCheck', 'orgDissolveNotice');
    });
    function go2page(path) {
      router.push(path);
    }
    return function (_ctx, _cache) {
      var _component_el_avatar = _resolveComponent("el-avatar");
      var _component_el_tooltip = _resolveComponent("el-tooltip");
      var _component_el_row = _resolveComponent("el-row");
      var _component_el_col = _resolveComponent("el-col");
      var _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["page", [_unref(loginType)]])
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("span", {
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return go2page('/');
        })
      }, _toDisplayString(_unref($t)('home.homeText')) + "/", 1), _createElementVNode("span", null, _toDisplayString(_unref($t)('home.personalCenterText')), 1)]), _createVNode(_component_el_row, {
        class: "contentBox"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_col, {
            class: "infoList"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_row, {
                class: "info"
              }, {
                default: _withCtx(function () {
                  var _unref2;
                  return [_createVNode(_component_el_tooltip, {
                    effect: "dark",
                    placement: "top",
                    content: _unref($t)('personalInformation.avatar.note')
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_el_avatar, {
                        size: 60,
                        src: "",
                        onError: errorHandler,
                        shape: "circle"
                      }, {
                        default: _withCtx(function () {
                          return [_createElementVNode("img", {
                            src: _unref(_get)(_unref($store), 'state.userInfo.avatarDfsID') ? _unref($getCdnUrl)({
                              bucket: _unref(_get)(_unref($store), 'state.userInfo.avatarBucket'),
                              dfsID: _unref(_get)(_unref($store), 'state.userInfo.avatarDfsID')
                            }) : _unref(_get)(_unref($store), 'state.userInfo.headImgUrl') || _unref(avatarPng),
                            alt: ""
                          }, null, 8, _hoisted_2), _createVNode(_unref(XlImgCropperOss), {
                            containerWidth: 240,
                            containerHeight: 240,
                            autoCropWidth: 240,
                            category: "avatar",
                            dialogTitle: _unref($t)('personalInformation.avatar.name'),
                            autoCropHeight: 240,
                            isCircle: true,
                            maxSize: 10,
                            outOfSizeTip: _unref($t)('personalInformation.avatar.outOfSizeTip', {
                              size: 10
                            }),
                            onUploaded: uploaded
                          }, null, 8, ["dialogTitle", "outOfSizeTip"])];
                        }),
                        _: 1
                      })];
                    }),
                    _: 1
                  }, 8, ["content"]), ((_unref2 = _unref(_get)(_unref($store), 'state.userInfo.nickName')) === null || _unref2 === void 0 ? void 0 : _unref2.length) < 24 ? (_openBlock(), _createBlock(_component_el_row, {
                    key: 0,
                    class: "name"
                  }, {
                    default: _withCtx(function () {
                      return [_createTextVNode(_toDisplayString(_unref(_get)(_unref($store), 'state.userInfo.nickName')), 1)];
                    }),
                    _: 1
                  })) : (_openBlock(), _createBlock(_component_el_tooltip, {
                    key: 1,
                    effect: "dark",
                    placement: "bottom",
                    "popper-class": "popper"
                  }, {
                    content: _withCtx(function () {
                      return [_createElementVNode("div", {
                        innerHTML: _unref(_get)(_unref($store), 'state.userInfo.nickName')
                      }, null, 8, _hoisted_3)];
                    }),
                    default: _withCtx(function () {
                      return [_createVNode(_component_el_row, {
                        class: "name"
                      }, {
                        default: _withCtx(function () {
                          return [_createTextVNode(_toDisplayString(_unref(_get)(_unref($store), 'state.userInfo.nickName')), 1)];
                        }),
                        _: 1
                      })];
                    }),
                    _: 1
                  })), _createVNode(_component_el_row, {
                    class: "userName"
                  }, {
                    default: _withCtx(function () {
                      return [_createTextVNode(_toDisplayString(_unref(_get)(_unref($store), 'state.userInfo.phone') || _unref(_get)(_unref($store), 'state.userInfo.email')), 1)];
                    }),
                    _: 1
                  })];
                }),
                _: 1
              }), _createVNode(_component_el_row, {
                class: "list"
              }, {
                default: _withCtx(function () {
                  return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(routerList.value, function (item) {
                    return _openBlock(), _createBlock(_component_el_col, {
                      class: _normalizeClass({
                        clickSide: _ctx.$route.path === item.path
                      }),
                      onClick: function onClick($event) {
                        return _ctx.$router.push(item.path);
                      },
                      key: item.path
                    }, {
                      default: _withCtx(function () {
                        return [_createElementVNode("i", {
                          class: _normalizeClass('icon iconfont ' + item.icon)
                        }, null, 2), _createTextVNode(_toDisplayString(item.name), 1)];
                      }),
                      _: 2
                    }, 1032, ["class", "onClick"]);
                  }), 128))];
                }),
                _: 1
              })];
            }),
            _: 1
          }), _createVNode(_component_el_col, {
            class: "infoUser"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_router_view)];
            }),
            _: 1
          })];
        }),
        _: 1
      }), _createVNode(privacyPolicy, {
        type: policyType.value,
        origin: "passport",
        title: policyTitle.value,
        ref_key: "termsOfUseRef",
        ref: termsOfUseRef
      }, null, 8, ["type", "title"])], 2);
    };
  }
};